module.exports = __webpack_public_path__ + "img/bago-small.f391c895.png";